import React from 'react'
import SearchResults from './components/search-results/SearchResults'
const DummyComponent = React.lazy(() => import('./components/DummyComponent'))
const SearchHeader = React.lazy(() => import('./components/search-header/SearchHeader'))

const SearchHeaderComponent = <SearchHeader />
const SearchRComponent = <SearchResults />

export type ReactComponentMappingType = Record<string, JSX.Element>

const reactComponentMapping: ReactComponentMappingType = {
  SearchHeader: SearchHeaderComponent,
  SearchResults: SearchRComponent,

  DummyComponent: <DummyComponent />
}
export default reactComponentMapping
